<template>
  <div>
    <div v-show="showInformations" class="wrapper">
      <div class="wrapper__card">
        <div class="wrapper__card__header">
          <div class="left">
            <span>CRIE, SELECIONE OU IMPORTE UM TEMPLATE</span>
          </div>
          <div class="right">
            <div>
              <z-input
                v-model="searchConnection"
                placeholder="Pesquisar"
                prependIcon="$search_rounded"
                type="text"
                :hideDetails="true"
              />
            </div>
            <div>
              <z-btn
                rounded
                primary
                text="Novo"
                icon="mdi-plus"
                small
                @click="$refs.contextMenu.open($event, 'data')"
              />

              <z-context-menu
                ref="contextMenu"
                :options="optionsMenu"
                @click="onClickContextAction"
              />
            </div>
            <div>
              <z-btn
                @click="showAudienceModal = true"
                small
                rounded
                text="ir para jornada"
                icon="mdi-arrow-collapse-right"
                :iconRight="true"
              />
            </div>
          </div>
        </div>
        <div ref="cardBody" class="wrapper__card__body">
          <z-pagination
            auto-pagination
            icon-previous="mdi-chevron-left"
            icon-next="mdi-chevron-right"
            :items-per-page="getNumberOfElements"
            :number-of-items="
              searchConnection ? filtered.length : allTemplates.lenth
            "
            :items="searchConnection ? filtered : allTemplates"
            @sort="sortTable"
          >
            <template #data="{ paginatedItems }">
              <div class="table-wrapper">
                <z-table
                  class="table"
                  :headers="headers"
                  :items="paginatedItems"
                  icon-next="mdi-chevron-right"
                  icon-previous="mdi-chevron-left"
                  @sort="sortTable"
                >
                  <template #no-data>
                    <div class="no-data-table">
                      <h3>Sem dados disponíveis.</h3>
                    </div>
                  </template>

                  <template v-slot:[`item.favorite`]="{ item }">
                    <div class="d-flex align-center justify-center">
                      <img
                        v-if="item.favorite"
                        :style="iconStyle"
                        src="/icons/favorite-icon.svg"
                        class="mr-1"
                        @click="favoriteTemplate(item)"
                      />
                      <img
                        v-else
                        :style="iconStyle"
                        src="/icons/favorite-not-filled-icon.svg"
                        class="mr-1"
                        @click="favoriteTemplate(item)"
                      />
                    </div>
                  </template>

                  <template v-slot:[`item.templateName`]="{ item }">
                    <strong>
                      <div class="d-flex align-center">
                        <img
                          v-if="item.favorite"
                          :style="iconStyle"
                          src="/icons/favorite-icon.svg"
                          class="mr-1"
                          @click="favoriteTemplate(item)"
                        />
                        <img
                          v-else
                          :style="iconStyle"
                          src="/icons/favorite-not-filled-icon.svg"
                          class="mr-1"
                          @click="favoriteTemplate(item)"
                        />
                        <span>
                          {{ item.templateName || "Sem registro" }}
                        </span>
                      </div>
                    </strong>
                  </template>

                  <template v-slot:[`item.createdAt`]="{ item }">
                    <span>{{ formateDate(item.createdAt) }} </span>
                  </template>

                  <template v-slot:[`item.databaseConfigId`]="{ item }"
                    >{{ getConnectionName(item) }}
                  </template>

                  <template
                    v-slot:[`item.infobipWhatsappTemplateStatus`]="{ item }"
                  >
                    <div class="status d-flex align-center" style="gap: 0.5rem">
                      <span
                        v-if="item?.infobipWhatsappTemplateStatus"
                        :style="
                          getStatusStyle(item.infobipWhatsappTemplateStatus)
                        "
                      >
                        {{ getStatusName(item.infobipWhatsappTemplateStatus) }}
                      </span>

                      <v-tooltip
                        v-if="
                          getStatusName(item.infobipWhatsappTemplateStatus) ==
                          'Rejected'
                        "
                        bottom
                        color="grey"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <span
                          style="
                            color: white;
                            padding: 0.5rem;
                            font-weight: 500;
                          "
                          >Motivo para a rejeição do template</span
                        >
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:[`item.templateType`]="{ item }">
                    <span
                      :style="getChipStyle(item.templateType.toLowerCase())"
                    >
                      {{ item.templateType.toUpperCase() }}
                    </span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="actions">
                      <v-tooltip
                        v-if="
                          ['sms', 'email', 'push'].includes(item.templateType)
                        "
                        bottom
                        color="grey"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1"
                            @click="selectOptionFromTable(item, 2)"
                            >$account_tree</v-icon
                          >
                        </template>
                        <span
                          style="
                            color: white;
                            padding: 0.5rem;
                            font-weight: 500;
                          "
                          >Jornada rápida</span
                        >
                      </v-tooltip>

                      <v-tooltip bottom color="grey">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1"
                            @click="selectOptionFromTable(item, 1)"
                            >$edit_outline</v-icon
                          >
                        </template>
                        <span
                          style="
                            color: white;
                            padding: 0.5rem;
                            font-weight: 500;
                          "
                          >Editar</span
                        >
                      </v-tooltip>
                      <v-tooltip bottom color="grey">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1"
                            @click="duplicateTemplate(item)"
                            >mdi-content-duplicate</v-icon
                          >
                        </template>
                        <span
                          style="
                            color: white;
                            padding: 0.5rem;
                            font-weight: 500;
                          "
                          >Duplicar Template</span
                        >
                      </v-tooltip>

                      <v-tooltip bottom color="grey">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1"
                            @click="selectOptionFromTable(item, 0)"
                            >$delete_outline_rounded</v-icon
                          >
                        </template>
                        <span
                          style="
                            color: white;
                            padding: 0.5rem;
                            font-weight: 500;
                          "
                          >Apagar</span
                        >
                      </v-tooltip>
                    </div>
                  </template>
                </z-table>
              </div>
            </template>
          </z-pagination>
          <!-- <div class="wrapper__card__body__table">
          </div> -->

          <!-- <ZAccordion
            icon="mdi-star"
            icon-color="#FFC220"
            title="Favoritos"
            :quantity="getFavorites.length"
          >
            <div class="wrapper__card__body__cards">
              <v-row dense>
                <v-col
                  v-for="(item, i) in getFavorites"
                  :key="i"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="4"
                >
                  <z-card
                    :title="item.templateName"
                    width="100%"
                    :shadow="true"
                    class="item"
                  >
                    <template #actions>
                      <div class="d-flex align-center justify-center">
                        <img
                          v-if="item.favorite"
                          :style="iconStyle"
                          src="/icons/favorite-icon.svg"
                          class="mr-1"
                          @click="favoriteTemplate(item)"
                        />
                        <img
                          v-else
                          :style="iconStyle"
                          src="/icons/favorite-not-filled-icon.svg"
                          class="mr-1"
                          @click="favoriteTemplate(item)"
                        />

                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <img
                              v-bind="attrs"
                              v-on="on"
                              :style="iconStyle2"
                              src="/icons/3-dots-icon.svg"
                            />
                          </template>

                          <div class="list-options">
                            <div
                              v-for="(option, index) in optionsMenu2"
                              :key="index"
                              class="list-options__item"
                              @click="selectDotOption(item, option)"
                            >
                              <span>
                                {{ option.text }}
                              </span>
                            </div>
                          </div>
                        </v-menu>
                      </div>
                    </template>
                    <template #content>
                      <div class="content" style="margin-top: 1rem">
                        <div>
                          <span>
                            {{ item.description }}
                          </span>
                        </div>

                        <div class="flag d-flex justify-end">
                          <span :style="flagStyle">{{
                            item.templateType.toLocaleUpperCase()
                          }}</span>
                        </div>
                      </div>
                    </template>
                  </z-card>
                </v-col>
              </v-row>
            </div>
          </ZAccordion>

          <ZAccordion
            icon="mdi-clock"
            icon-color="#FF8F28"
            title="Todos"
            :quantity="!searchConnection ? allTemplates.length : filtered.length"
          >
            <div class="wrapper__card__body__cards">
              <template v-if="!searchConnection">
                <v-row dense>
                  <v-col
                    v-for="(item, i) in allTemplates"
                    :key="i"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="4"
                  >
                    <z-card
                      :title="item.templateName"
                      width="100%"
                      :shadow="true"
                      class="item"
                    >
                      <template #actions>
                        <div class="d-flex align-center justify-center">
                          <img
                            v-if="item.favorite"
                            :style="iconStyle"
                            src="/icons/favorite-icon.svg"
                            class="mr-1"
                            @click="favoriteTemplate(item)"
                          />
                          <img
                            v-else
                            :style="iconStyle"
                            src="/icons/favorite-not-filled-icon.svg"
                            class="mr-1"
                            @click="favoriteTemplate(item)"
                          />

                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <img
                                v-bind="attrs"
                                v-on="on"
                                :style="iconStyle2"
                                src="/icons/3-dots-icon.svg"
                              />
                            </template>

                            <div class="list-options">
                              <div
                                v-for="(option, index) in optionsMenu2"
                                :key="index"
                                class="list-options__item"
                                @click="selectDotOption(item, option)"
                              >
                                <span>
                                  {{ option.text }}
                                </span>
                              </div>
                            </div>
                          </v-menu>
                        </div>
                      </template>

                      <template #content>
                        <div class="content" style="margin-top: 1rem">
                          <div>
                            <span>
                              {{ item.description }}
                            </span>
                          </div>
                          <div class="flag d-flex justify-end">
                            <span :style="flagStyle">{{
                              item.templateType.toLocaleUpperCase()
                            }}</span>
                          </div>
                        </div>
                      </template>
                    </z-card>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row dense>
                  <v-col
                    v-for="(item, i) in filtered"
                    :key="i"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="4"
                  >
                    <z-card
                      :title="item.templateName"
                      width="100%"
                      :shadow="true"
                      class="item"
                    >
                      <template #actions>
                        <div class="d-flex align-center justify-center">
                          <img
                            v-if="item.favorite"
                            :style="iconStyle"
                            src="/icons/favorite-icon.svg"
                            class="mr-1"
                            @click="favoriteTemplate(item)"
                          />
                          <img
                            v-else
                            :style="iconStyle"
                            src="/icons/favorite-not-filled-icon.svg"
                            class="mr-1"
                            @click="favoriteTemplate(item)"
                          />

                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <img
                                v-bind="attrs"
                                v-on="on"
                                :style="iconStyle2"
                                src="/icons/3-dots-icon.svg"
                              />
                            </template>

                            <div class="list-options">
                              <div
                                v-for="(option, index) in optionsMenu2"
                                :key="index"
                                class="list-options__item"
                                @click="selectDotOption(item, option)"
                              >
                                <span>
                                  {{ option.text }}
                                </span>
                              </div>
                            </div>
                          </v-menu>
                        </div>
                      </template>

                      <template #content>
                        <div class="content" style="margin-top: 1rem">
                          <div>
                            <span>
                              {{ item.description }}
                            </span>
                          </div>
                          <div class="flag d-flex justify-end">
                            <span :style="flagStyle">{{
                              item.templateType.toLocaleUpperCase()
                            }}</span>
                          </div>
                        </div>
                      </template>
                    </z-card>
                  </v-col>
                </v-row>
              </template>
            </div>
          </ZAccordion> -->

          <!-- <div class="wrapper__card__body--actions">
            <z-btn
              text="Voltar"
              color="primary"
              :rounded="true"
              icon="$arrow_back_rounded"
              @click="$router.push('/')"
            />
          </div> -->
        </div>
      </div>

      <v-dialog v-model="showSelectJourneyModal" width="900">
        <SelectJourneyModal
          v-if="showSelectJourneyModal"
          @close="showSelectJourneyModal = false"
          @editJourney="editJourney"
        />
      </v-dialog>

      <z-card-modal
        v-model="showAudienceModal"
        width="500"
        title="Como você quer começar?"
      >
        <template #content>
          <div class="cards-audience" :style="cardAudienceStyle2">
            <div
              v-for="(item, i) in audienceModalData"
              :key="i"
              class="cards-audience__item"
              :style="cardAudienceStyle"
              @click="chooseMethodToJourney(item.value)"
            >
              <div class="header" style="text-align: center">
                <figure style="width: 30px; height: 30px; margin: 0 auto">
                  <img
                    :src="item.icon"
                    style="width: 100%; height: 100%; object-fit: contain"
                  />
                </figure>
                <strong style="text-transform: uppercase; font-size: 0.85em">
                  {{ item.name }}
                </strong>
              </div>
              <div class="body" style="text-align: center; font-size: 1em">
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
        </template>
      </z-card-modal>

      <z-card-modal v-model="emailDialog" width="800" title="Novo e-mail">
        <template #content>
          <div class="cards-audience" :style="cardAudienceStyle2">
            <div
              v-for="(item, i) in emailModalData"
              :key="i"
              class="cards-audience__item"
              :style="cardAudienceStyle"
              @click="goToPage(item)"
            >
              <div class="header" style="text-align: center">
                <figure style="width: 30px; height: 30px; margin: 0 auto">
                  <img
                    :src="item.icon"
                    style="width: 100%; height: 100%; object-fit: contain"
                  />
                </figure>
                <strong style="text-transform: uppercase; font-size: 0.85em">
                  {{ item.name }}
                </strong>
              </div>
              <div class="body" style="text-align: center; font-size: 1em">
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
          <div class="action d-flex justify-end py-2">
            <z-btn large text="cancelar" @click="emailDialog = false" />
          </div>
        </template>
      </z-card-modal>

      <z-card-modal v-model="pushDialog" width="500" title="Novo push">
        <template #content>
          <div class="cards-audience" :style="cardAudienceStyle2">
            <div
              v-for="(item, i) in pushModalData"
              :key="i"
              class="cards-audience__item"
              :style="cardAudienceStyle"
              @click="goToPage(item)"
            >
              <div class="header" style="text-align: center">
                <figure style="width: 30px; height: 30px; margin: 0 auto">
                  <img
                    :src="item.icon"
                    style="width: 100%; height: 100%; object-fit: contain"
                  />
                </figure>
                <strong style="text-transform: uppercase; font-size: 0.85em">
                  {{ item.name }}
                </strong>
              </div>
              <div class="body" style="text-align: center; font-size: 1em">
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
          <div class="action d-flex justify-end py-2">
            <z-btn large text="cancelar" @click="pushDialog = false" />
          </div>
        </template>
      </z-card-modal>

      <z-card-modal v-model="smsDialog" width="500" title="Selecionar sms">
        <template #content>
          <div class="cards-audience" :style="cardAudienceStyle2">
            <div
              v-for="(item, i) in smsModalData"
              :key="i"
              class="cards-audience__item"
              :style="cardAudienceStyle"
              @click="goToPage(item)"
            >
              <div class="header" style="text-align: center">
                <figure style="width: 30px; height: 30px; margin: 0 auto">
                  <img
                    :src="item.icon"
                    style="width: 100%; height: 100%; object-fit: contain"
                  />
                </figure>
                <strong style="text-transform: uppercase; font-size: 0.85em">
                  {{ item.name }}
                </strong>
              </div>
              <div class="body" style="text-align: center; font-size: 1em">
                <span>{{ item.description }}</span>
              </div>
            </div>
          </div>
          <div class="action d-flex justify-end py-2">
            <z-btn large text="cancelar" @click="smsDialog = false" />
          </div>
        </template>
      </z-card-modal>

      <z-card-modal v-model="dialogDelete" width="400" title="">
        <template #content>
          <div class="delete-confirmation">
            <div
              class="delete-confirmation__title mb-5"
              style="justify-content: center; display: flex !important"
            >
              <span><strong>Confirmar apagar este template?</strong></span>
            </div>

            <div
              class="delete-confirmation--actions"
              style="justify-content: space-evenly; display: flex"
            >
              <z-btn
                small
                rounded
                text="cancelar"
                @click="
                  dialogDelete = false;
                  templateToBeDeleted = null;
                "
              />

              <z-btn
                rounded
                primary
                text="apagar"
                small
                :isLoading="loadingDelete"
                @click="confirmDeleteTemplate()"
              />
            </div>
          </div>
        </template>
      </z-card-modal>
    </div>
    <div v-show="!showInformations" class="wrapper no-data">
      <div class="wrapper__card">
        <z-loading />
      </div>
    </div>

    <z-card-modal
      v-model="confirmationFastJourney"
      width="600"
      title="tem certeza que deixar criar uma nova jornada com esse template?"
    >
      <template #content>
        <div class="fast-journey-modal">
          <div class="pt-3 pb-5">
            <span>
              Template selecionado:
              <strong>{{ fastJourneyCurrentTemplate.templateName }}</strong>
            </span>
            <br />
            <span> Selecione uma audiência abaixo para dar proseguimento </span>
          </div>
          <div>
            <v-form ref="confirmFastForm">
              <z-autocomplete
                label="Audiência"
                v-model="choosenAudience"
                :items="currentAudiencesList"
                itemText="name"
                placeholder="Pesquisar"
                type="text"
                :hideDetails="true"
                returnObject
                :rules="[(v) => !!v || 'Campo obrigatório']"
              />
            </v-form>
            <div class="content__timer-type mb-5" style="margin-top: 10px">
              <div class="repeat-each mb-0">
                <strong class="mb-2"> Tipo: </strong>
              </div>
              <!-- ESCOLHA DE PONTUAL OU RECORRENTE -->
              <v-radio-group
                v-model="timerType"
                :rules="[(v) => !!v || 'Campo obrigatório']"
                hide-details
                row
                small
              >
                <v-radio small style="width: 150px" value="punctual">
                  <template #label>
                    <span style="color: #000000">Pontual</span>
                  </template>
                </v-radio>
                <v-radio style="width: 150px" value="recurring">
                  <template #label>
                    <span style="color: #000000">Recorrente</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <!-- SEÇÃO PONTUAL -->

            <section
              v-if="timerType == 'punctual'"
              class="content__punctual-info mt-3"
            >
              <v-radio-group
                v-model="startType"
                :rules="[(v) => !!v || 'Campo obrigatório']"
                hide-details
                @change="executeTime = ''"
              >
                <v-radio style="width: 150px" value="immediate">
                  <template #label>
                    <span style="color: #000000">Imediato</span>
                  </template>
                </v-radio>
                <v-radio value="date">
                  <template #label>
                    <span class="mr-5" style="color: #000000"
                      >Agendamento
                    </span>
                  </template>
                </v-radio>
              </v-radio-group>

              <div v-if="startType == 'date'">
                <v-row dense>
                  <v-col cols="12" lg="6" md="6" sm="6">
                    <z-input-date
                      v-model="punctualTimerType"
                      :disabled="startType != 'date'"
                      :hideDetails="true"
                      :min="minimumStartDate"
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                      class="mr-1"
                      format="pt-BR"
                      label=""
                      small
                      type="date"
                    />
                  </v-col>

                  <v-col cols="12" lg="3" md="3" sm="3">
                    <z-select
                      v-model="hourInfo"
                      :hideDetails="true"
                      :items="
                        actualSelectedDateIsToday ? avaliableHours : hoursArr
                      "
                      :readonly="!punctualTimerType"
                      hint="asdfasdf"
                      label="Hora"
                      small
                  /></v-col>

                  <v-col cols="12" lg="3" md="3" sm="3">
                    <z-select
                      v-model="minuteInfo"
                      :hideDetails="true"
                      :items="
                        actualSelectedDateIsToday
                          ? avaliableMinutes
                          : minutesArr
                      "
                      :readonly="!punctualTimerType"
                      label="Minuto"
                      small
                  /></v-col>

                  <v-col
                    v-if="actualSelectedDateIsToday && hourInfo && minuteInfo"
                    class="mt-3"
                    cols="12"
                  >
                    <small class="d-flex"
                      >*Agendado previamente para:
                      <strong class="ml-2">{{
                        formatDate(punctualTimerType)
                      }}</strong>
                      <strong class="ml-2"
                        >{{ hourInfo }}:{{ minuteInfo }}</strong
                      >
                    </small>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="6" lg="6">
                    <z-input
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                      v-model="executeTime"
                      class="ml-2"
                      small
                      type="time"
                      clearable
                      clear-icon="mdi-close-thick"
                      :hideDetails="true"
                    />
                  </v-col> -->
                </v-row>
              </div>
            </section>

            <!-- SEÇÃO RECORRENTE -->
            <section
              v-if="timerType == 'recurring'"
              class="content__recurring-info"
            >
              <div class="start mb-5">
                <strong class="mb-0"> Início</strong>

                <v-radio-group
                  v-model="startType"
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                  hide-details
                  inline
                  @change="startType != 'date' ? (punctualTimerType = '') : ''"
                >
                  <v-row>
                    <v-radio
                      style="width: 150px; margin-top: 10px"
                      value="immediate"
                    >
                      <template #label>
                        <span style="color: #000000">Imediato</span>
                      </template>
                    </v-radio>
                    <v-radio value="date">
                      <template #label>
                        <v-col cols="9">
                          <z-input-date
                            v-model="punctualTimerType"
                            :disabled="startType != 'date'"
                            :hideDetails="true"
                            :rules="
                              startType === 'date'
                                ? [(v) => !!v || 'Campo obrigatório']
                                : []
                            "
                            class="mr-1"
                            format="pt-BR"
                            label=""
                            type="date"
                          />
                        </v-col>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>

                <div v-if="startType == 'date'">
                  <v-row dense> </v-row>
                </div>
              </div>

              <div class="end mb-5">
                <strong class="mb-0"> Fim </strong>

                <v-radio-group
                  v-model="endType"
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                  hide-details
                  inline
                  @change="punctualTimerTypeEnd = ''"
                >
                  <v-row>
                    <v-radio
                      style="width: 150px; margin-top: 10px"
                      value="undefined"
                    >
                      <template #label>
                        <span style="color: #000000">Indefinido </span>
                      </template>
                    </v-radio>
                    <v-radio value="date">
                      <template #label>
                        <v-col cols="9">
                          <z-input-date
                            v-model="punctualTimerTypeEnd"
                            :disabled="endType != 'date'"
                            :hideDetails="true"
                            :min="minimumDate"
                            :rules="
                              endType === 'date'
                                ? [(v) => !!v || 'Campo obrigatório']
                                : []
                            "
                            format="pt-BR"
                            label=""
                          />
                        </v-col>
                      </template>
                    </v-radio>
                  </v-row>
                </v-radio-group>
              </div>

              <div class="repeat-each mb-0">
                <strong class="mb-2"> Repetir a cada: </strong>
              </div>

              <div class="repeat-each mb-5">
                <v-row dense>
                  <v-col cols="12" lg="3" md="6" sm="12">
                    <z-input
                      ref="inptRef"
                      v-model="every"
                      :hide-details="true"
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                      class="custom_inpt"
                      itemText="text"
                      itemValue="value"
                      type="number"
                    ></z-input>
                  </v-col>
                  <v-col cols="12" lg="4" md="6" sm="12">
                    <z-select
                      ref="selectRef"
                      v-model="repeatItem"
                      :hide-details="true"
                      :items="repeatItems"
                      :rules="[(v) => !!v || 'Campo obrigatório']"
                      itemText="text"
                      itemValue="value"
                      value-position="center"
                    ></z-select>
                  </v-col>
                </v-row>
              </div>

              <div
                v-if="repeatItem == 'weekly' || repeatItem == 'monthly'"
                class="repeat mb-5"
              >
                <strong class="mb-2"> Repetir: </strong>

                <v-btn-toggle
                  v-if="repeatItem == 'weekly'"
                  v-model="toggle_week"
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                  color="primary"
                  dense
                  multiple
                >
                  <v-btn class="mr-1" depressed fab rounded x-small> D </v-btn>
                  <v-btn class="mr-1" depressed fab rounded x-small> S </v-btn>
                  <v-btn class="mr-1" depressed fab rounded x-small> T </v-btn>
                  <v-btn class="mr-1" depressed fab rounded x-small> Q </v-btn>
                  <v-btn class="mr-1" depressed fab rounded x-small> Q </v-btn>
                  <v-btn class="mr-1" depressed fab rounded x-small> S </v-btn>
                  <v-btn class="mr-1" depressed fab rounded x-small> S </v-btn>
                </v-btn-toggle>

                <div v-if="repeatItem == 'monthly'">
                  <v-row justify="space-between">
                    <v-col cols="5">
                      <z-input
                        v-if="repeatItem == 'monthly'"
                        ref="inptRef"
                        v-model="toggle_month_choose"
                        :hide-details="true"
                        :rules="[(v) => !!v || 'Campo obrigatório']"
                        class="custom_inpt mt-4"
                        itemText="text"
                        label="dia"
                        itemValue="value"
                        max="31"
                        min="1"
                        type="number"
                      ></z-input>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div
                v-if="repeatItem !== 'minutely' && repeatItem !== 'hourly'"
                class="execution mb-1"
              >
                <strong class="mb-2"> Horário de execução </strong>

                <!-- <z-input
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                  v-model="executeTime"
                  class="ml-2"
                  type="time"
                  clearable
                  clear-icon="mdi-close-thick"
                  :hideDetails="true"
                /> -->
                <v-row dense>
                  <v-col cols="12" lg="3" md="6" sm="6">
                    <z-select
                      v-model="hourInfo"
                      :items="hoursArr"
                      hideDetails
                      label="Hora"
                  /></v-col>
                  <v-col cols="12" lg="3" md="6" sm="6">
                    <z-select
                      v-model="minuteInfo"
                      :items="minutesArr"
                      hideDetails
                      label="Minuto"
                  /></v-col>
                </v-row>
              </div>

              <div class="content__timer-type mt-5">
                <strong class="mb-2">
                  Quando um usuário já estiver na jornada
                </strong>

                <v-radio-group
                  v-model="newUserJourneyEntryBehavior"
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                  hide-details
                  inline
                >
                  <v-radio style="margin-top: 10px" value="createNew">
                    <template #label>
                      <span style="color: #000000">Criar novamente</span>
                    </template>
                  </v-radio>
                  <v-radio style="margin-top: 10px" value="noChange">
                    <template #label>
                      <span style="color: #000000"
                        >Não criar um novo e não alterar o existente</span
                      >
                    </template>
                  </v-radio>
                  <v-radio style="margin-top: 10px" value="backToBeginning">
                    <template #label>
                      <span style="color: #000000"
                        >Não criar um novo e mover o existente para o
                        início</span
                      >
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </section>
            <div class="content__timer-type mt-5">
              <strong class="mb-2"> Ao aguardar: </strong>

              <v-radio-group
                v-model="userWaitBehaviour"
                :rules="[(v) => !!v || 'Campo obrigatório']"
                hide-details
                inline
              >
                <v-radio style="margin-top: 10px" value="noChange">
                  <template #label>
                    <span style="color: #000000">Manter dados do inicio</span>
                  </template>
                </v-radio>
                <v-radio style="margin-top: 10px" value="updateData">
                  <template #label>
                    <span style="color: #000000">Atualizar dados</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <!-- SEÇÃO DUPLICIDADE -->
            <div class="content__timer-type mt-5">
              <strong class="mb-2">
                Configuração de envio em duplicidade
              </strong>

              <div class="repeat-each mb-3">
                <v-row dense>
                  <v-col cols="12" lg="12" md="12" sm="12">
                    <v-tooltip max-width="700" top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on"
                          ><z-checkbox
                            v-model="shouldSentMensageriaToExistentContact"
                            hide-details
                            label="Não permitir o envio para o mesmo número e e-mail na mesma jornada"
                            v-bind="attrs"
                            v-on="on"
                        /></span>
                      </template>
                      <span
                        style="padding: 1rem; font-weight: 500; display: block"
                      >
                        Essa opcao impede que sejam enviados dois emails/sms
                        para usuarios que por acaso tenham o mesmo email ou
                        telefone cadastrado na base, caso a sua base nao tenha
                        emails/sms duplicados, isso nao e necessario e afetaria
                        a velocidade desnecessariamente
                      </span>
                    </v-tooltip>

                    <small
                      v-if="shouldSentMensageriaToExistentContact"
                      style="color: red"
                      ><strong
                        >A opção de envio em duplicidade pode afetar a
                        velocidade no envio das mensagens</strong
                      ></small
                    >
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- IGNORAR OPTOUT -->
            <div class="content__timer-type mt-5">
              <strong class="mb-2"> Configuração de optout </strong>

              <div class="repeat-each mb-3">
                <v-row dense>
                  <v-col cols="12" lg="12" md="12" sm="12">
                    <z-checkbox
                      v-model="ignoreOptout"
                      hide-details
                      label="Ignorar optout"
                    />
                  </v-col>
                </v-row>
              </div>
            </div>

            <div class="content__timer-type mt-5">
              <strong class="mb-2">
                Ignorar usuarios nas seguintes jornadas:</strong
              >
              <div class="repeat-each mb-3">
                <v-row dense>
                  <v-col cols="12" lg="12" md="12" sm="12">
                    <z-autocomplete
                      v-model="ignoreJourneys"
                      :hideDetails="true"
                      :items="journeys"
                      itemText="name"
                      itemValue="id"
                      multiple
                      placeholder=""
                      type="text"
                    />
                  </v-col>
                </v-row>
              </div>
            </div>

            <div class="content__timer-type mt-5">
              <strong class="mb-2">
                Emails para notificar na finalização:</strong
              >
              <div class="repeat-each mb-3">
                <v-row dense>
                  <v-col cols="12" lg="12" md="12" sm="12">
                    <z-input
                      v-model="finishNotificationEmails"
                      :hide-details="true"
                    ></z-input>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
          <div class="pt-5 pb-1 d-flex justify-end">
            <z-btn
              text="Cancelar"
              rounded
              class="mr-2"
              @click="confirmationFastJourney = false"
            />
            <z-btn
              text="Confirmar"
              primary
              rounded
              :disabled="!choosenAudience"
              @click="createSimpleJourney"
            />
          </div>
        </div>
      </template>
    </z-card-modal>
  </div>
</template>

<script>
import moment from "moment";
import ApiClient from "@/services/ApiClient";
// import ZAccordion from "@/components/Shared/ZAccordion.vue";
import SelectJourneyModal from "./modals/selectJourneyModal.vue";
export default {
  name: "IndexTemplates",
  components: {
    // ZAccordion,
    SelectJourneyModal,
  },
  data() {
    return {
      // templatesMock: [
      //   {
      //     id: "dcde6eb4-7a42-4776-989b-a1bfb380419f",
      //     templateType: "sms",
      //     templateName: "SMS_Base_reduzida",
      //     description: "",
      //     pushTitle: null,
      //     pushImageUrl: null,
      //     redirectUrl: null,
      //     message: "Teste reduzido $Nome 1",
      //     updatedAt: "2024-01-04T14:17:06.632Z",
      //     createdAt: "2023-08-14T16:46:44.765Z",
      //     favorite: true,
      //     databaseConfigId: "609db725-0f00-40e7-9a55-eaf23eec2475",
      //     company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //     group_id: null,
      //     emailSubject: null,
      //     senderName: null,
      //     emailSender: null,
      //     replyTo: null,
      //     allowOptout: null,
      //     defaultValues: "{}",
      //     utm_source: null,
      //     utm_medium: null,
      //     utm_campaign: null,
      //     utm_id: null,
      //     utm_term: null,
      //     utm_content: null,
      //     infobipWhatsappTemplateId: ";",
      //     infobipWhatsappTemplateName: ";",
      //     infobipWhatsappTemplateMappingFields: ";",
      //     databaseConfig: {
      //       id: "609db725-0f00-40e7-9a55-eaf23eec2475",
      //       lastUpdate: "2023-08-14T16:45:19.331Z",
      //       nextUpdate: "2023-08-14T16:45:19.199Z",
      //       status: "updated",
      //       company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //       group_id: null,
      //       name: "Base_reduzida_andre",
      //       dbIntegrationId: null,
      //       updated: "2023-08-14T16:45:19.199Z",
      //       created: "2023-08-14T16:45:19.199Z",
      //       cron: null,
      //       table: null,
      //       fields:
      //         '{"ID":{"origins":["ID"],"type":"integer","format":null},"Nome":{"origins":["Nome"],"type":"string","format":null},"id":{"origins":["ID"],"type":"string"},"name":{"origins":["Nome"],"type":"string"},"sdkId":{"origins":[],"type":"string"},"email":{"origins":["email"],"type":"string"},"phone":{"origins":["Celular"],"type":"string"},"adicionei3":{"origins":["Celular"],"type":"string"}}',
      //       primaryColumn: null,
      //       controlColumn: "",
      //       favorite: true,
      //       hasUpdatedAt: null,
      //       typeConfig: "csv",
      //       csvUrl: "CSVs/1692031469799-Teste_data_to_act_v2.csv",
      //       csvSeparator: ";",
      //       apiEnabled: false,
      //       apiToken: "c3cea0ff-a040-4246-94a6-73a9118c2b1f",
      //       skuType: null,
      //       csvLinebreak: ";",
      //       errorBehaviour: "break",
      //     },
      //   },
      //   {
      //     id: "4326fa78-03ab-490f-98de-72bed4b68c90",
      //     templateType: "sms",
      //     templateName: "TESTE_ZOOX",
      //     description: "",
      //     pushTitle: null,
      //     pushImageUrl: null,
      //     redirectUrl: null,
      //     message:
      //       "LeBonTon: O Inverno chegou no LeBonTon! Use seu saldo de R$ $SALDO_FIDELIDADE  e prove o nosso delicioso Escondidinho de Frango de R$32,90. Vem!",
      //     updatedAt: "2023-09-22T19:13:01.062Z",
      //     createdAt: "2023-07-06T16:02:19.628Z",
      //     favorite: true,
      //     databaseConfigId: "b14b3807-9995-43b9-bd59-2609c686dee5",
      //     company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //     group_id: null,
      //     emailSubject: null,
      //     senderName: null,
      //     emailSender: null,
      //     replyTo: null,
      //     allowOptout: null,
      //     defaultValues: null,
      //     utm_source: null,
      //     utm_medium: null,
      //     utm_campaign: null,
      //     utm_id: null,
      //     utm_term: null,
      //     utm_content: null,
      //     infobipWhatsappTemplateId: ";",
      //     infobipWhatsappTemplateName: ";",
      //     infobipWhatsappTemplateMappingFields: ";",
      //     databaseConfig: {
      //       id: "b14b3807-9995-43b9-bd59-2609c686dee5",
      //       lastUpdate: "2023-07-06T14:59:46.881Z",
      //       nextUpdate: "2023-07-06T14:59:46.804Z",
      //       status: "updated",
      //       company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //       group_id: null,
      //       name: "TESTE_TRIGO_CRM",
      //       dbIntegrationId: null,
      //       updated: "2023-07-06T14:59:46.804Z",
      //       created: "2023-07-06T14:59:46.804Z",
      //       cron: null,
      //       table: null,
      //       fields:
      //         '{"NOME_MARCA":{"origins":["NOME_MARCA"],"type":"string","format":null},"ID_CLIENTE":{"origins":["ID_CLIENTE"],"type":"integer","format":null},"CELULAR":{"origins":["CELULAR"],"type":"integer","format":null},"CPF":{"origins":["CPF"],"type":"integer","format":null},"EMAIL":{"origins":["EMAIL"],"type":"string","format":null},"NOME":{"origins":["NOME"],"type":"string","format":null},"DATA_NASCIMENTO":{"origins":["DATA_NASCIMENTO"],"type":"string","format":null},"CLIENTE_IMPORTADO":{"origins":["CLIENTE_IMPORTADO"],"type":"string","format":null},"ACEITOU_PROGRAMA_FIDELIDADE":{"origins":["ACEITOU_PROGRAMA_FIDELIDADE"],"type":"string","format":null},"DATA_ACEITE_PROGRAMA_FIDELIDADE":{"origins":["DATA_ACEITE_PROGRAMA_FIDELIDADE"],"type":"date","format":"DD/MM/YYYY"},"DATA_ULTIMA_COMPRA":{"origins":["DATA_ULTIMA_COMPRA"],"type":"date","format":"DD/MM/YYYY"},"NIVEL_FIDELIDADE":{"origins":["NIVEL_FIDELIDADE"],"type":"string","format":null},"DATA_VALIDADE_NIVEL":{"origins":["DATA_VALIDADE_NIVEL"],"type":"date","format":"DD/MM/YYYY"},"QTD_COMPRAS_QUALIFI_NIVEL_MES":{"origins":["QTD_COMPRAS_QUALIFI_NIVEL_MES"],"type":"integer","format":null},"SALDO_FIDELIDADE":{"origins":["SALDO_FIDELIDADE"],"type":"decimal","format":null},"NOME_LOJA_ORIGEM":{"origins":["NOME_LOJA_ORIGEM"],"type":"string","format":null},"id":{"origins":["ID_CLIENTE"],"type":"string"},"name":{"origins":["NOME"],"type":"string"},"sdkId":{"origins":[],"type":"string"},"email":{"origins":["EMAIL"],"type":"string"},"phone":{"origins":["\'55\'","CELULAR"],"type":"string"}}',
      //       primaryColumn: null,
      //       controlColumn: "",
      //       favorite: false,
      //       hasUpdatedAt: null,
      //       typeConfig: "csv",
      //       csvUrl: "CSVs/1688655528600-TESTE_TRIGO.csv",
      //       csvSeparator: ";",
      //       apiEnabled: false,
      //       apiToken: "bc83afe2-5463-47f5-88ba-b8ae097c3f6b",
      //       skuType: null,
      //       csvLinebreak: "\r\n",
      //       errorBehaviour: "ignore",
      //     },
      //   },
      //   {
      //     id: "460f7e07-1eda-4fea-b890-9c957c926467",
      //     templateType: "sms",
      //     templateName: "TESTE_ZOOX",
      //     description: "",
      //     pushTitle: null,
      //     pushImageUrl: null,
      //     redirectUrl: null,
      //     message:
      //       "LeBonTon: O Inverno chegou no LeBonTon! Use seu saldo de R$ $SALDO_FIDELIDADE  e prove o nosso delicioso Escondidinho de Frango de R$32,90. Vem!",
      //     updatedAt: "2023-10-03T21:12:16.988Z",
      //     createdAt: "2023-07-06T16:02:19.628Z",
      //     favorite: true,
      //     databaseConfigId: "b14b3807-9995-43b9-bd59-2609c686dee5",
      //     company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //     group_id: null,
      //     emailSubject: null,
      //     senderName: null,
      //     emailSender: null,
      //     replyTo: null,
      //     allowOptout: null,
      //     defaultValues: null,
      //     utm_source: null,
      //     utm_medium: null,
      //     utm_campaign: null,
      //     utm_id: null,
      //     utm_term: null,
      //     utm_content: null,
      //     infobipWhatsappTemplateId: ";",
      //     infobipWhatsappTemplateName: ";",
      //     infobipWhatsappTemplateMappingFields: ";",
      //     databaseConfig: {
      //       id: "b14b3807-9995-43b9-bd59-2609c686dee5",
      //       lastUpdate: "2023-07-06T14:59:46.881Z",
      //       nextUpdate: "2023-07-06T14:59:46.804Z",
      //       status: "updated",
      //       company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //       group_id: null,
      //       name: "TESTE_TRIGO_CRM",
      //       dbIntegrationId: null,
      //       updated: "2023-07-06T14:59:46.804Z",
      //       created: "2023-07-06T14:59:46.804Z",
      //       cron: null,
      //       table: null,
      //       fields:
      //         '{"NOME_MARCA":{"origins":["NOME_MARCA"],"type":"string","format":null},"ID_CLIENTE":{"origins":["ID_CLIENTE"],"type":"integer","format":null},"CELULAR":{"origins":["CELULAR"],"type":"integer","format":null},"CPF":{"origins":["CPF"],"type":"integer","format":null},"EMAIL":{"origins":["EMAIL"],"type":"string","format":null},"NOME":{"origins":["NOME"],"type":"string","format":null},"DATA_NASCIMENTO":{"origins":["DATA_NASCIMENTO"],"type":"string","format":null},"CLIENTE_IMPORTADO":{"origins":["CLIENTE_IMPORTADO"],"type":"string","format":null},"ACEITOU_PROGRAMA_FIDELIDADE":{"origins":["ACEITOU_PROGRAMA_FIDELIDADE"],"type":"string","format":null},"DATA_ACEITE_PROGRAMA_FIDELIDADE":{"origins":["DATA_ACEITE_PROGRAMA_FIDELIDADE"],"type":"date","format":"DD/MM/YYYY"},"DATA_ULTIMA_COMPRA":{"origins":["DATA_ULTIMA_COMPRA"],"type":"date","format":"DD/MM/YYYY"},"NIVEL_FIDELIDADE":{"origins":["NIVEL_FIDELIDADE"],"type":"string","format":null},"DATA_VALIDADE_NIVEL":{"origins":["DATA_VALIDADE_NIVEL"],"type":"date","format":"DD/MM/YYYY"},"QTD_COMPRAS_QUALIFI_NIVEL_MES":{"origins":["QTD_COMPRAS_QUALIFI_NIVEL_MES"],"type":"integer","format":null},"SALDO_FIDELIDADE":{"origins":["SALDO_FIDELIDADE"],"type":"decimal","format":null},"NOME_LOJA_ORIGEM":{"origins":["NOME_LOJA_ORIGEM"],"type":"string","format":null},"id":{"origins":["ID_CLIENTE"],"type":"string"},"name":{"origins":["NOME"],"type":"string"},"sdkId":{"origins":[],"type":"string"},"email":{"origins":["EMAIL"],"type":"string"},"phone":{"origins":["\'55\'","CELULAR"],"type":"string"}}',
      //       primaryColumn: null,
      //       controlColumn: "",
      //       favorite: false,
      //       hasUpdatedAt: null,
      //       typeConfig: "csv",
      //       csvUrl: "CSVs/1688655528600-TESTE_TRIGO.csv",
      //       csvSeparator: ";",
      //       apiEnabled: false,
      //       apiToken: "bc83afe2-5463-47f5-88ba-b8ae097c3f6b",
      //       skuType: null,
      //       csvLinebreak: "\r\n",
      //       errorBehaviour: "ignore",
      //     },
      //   },
      //   {
      //     id: "8afe9926-d86a-4704-aab5-34e14475db1d",
      //     templateType: "whatsapp",
      //     templateName: "Teste",
      //     description: "",
      //     pushTitle: null,
      //     pushImageUrl: null,
      //     redirectUrl: null,
      //     message: "asdf",
      //     updatedAt: "2024-05-09T17:17:33.871Z",
      //     createdAt: "2024-05-09T17:17:33.871Z",
      //     favorite: false,
      //     databaseConfigId: "07eaa47e-b121-4bb3-8cf7-3ee884613718",
      //     company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //     group_id: null,
      //     emailSubject: null,
      //     senderName: null,
      //     emailSender: null,
      //     replyTo: null,
      //     allowOptout: null,
      //     defaultValues: null,
      //     utm_source: null,
      //     utm_medium: null,
      //     utm_campaign: null,
      //     utm_id: null,
      //     utm_term: null,
      //     utm_content: null,
      //     infobipWhatsappTemplateId: "215745978146695",
      //     infobipWhatsappTemplateName: null,
      //     infobipWhatsappTemplateMappingFields: "{}",
      //     infobipWhatsappTemplateStatus: "REJECTED",
      //     databaseConfig: {
      //       id: "07eaa47e-b121-4bb3-8cf7-3ee884613718",
      //       lastUpdate: "2024-02-22T02:51:32.990Z",
      //       nextUpdate: "2024-02-22T02:51:32.629Z",
      //       status: "updated",
      //       company_id: "2153b43a-596f-43dc-808c-d51d7595f682",
      //       group_id: null,
      //       name: "teste_import",
      //       dbIntegrationId: null,
      //       updated: "2024-02-22T02:51:32.629Z",
      //       created: "2024-02-22T02:51:32.629Z",
      //       cron: null,
      //       table: null,
      //       fields:
      //         '{"ano_evento":{"origins":["ano_evento"],"type":"integer","format":null},"id do ingresso":{"origins":["id do ingresso"],"type":"integer","format":null},"id do pedido":{"origins":["id do pedido"],"type":"integer","format":null},"evento":{"origins":["evento"],"type":"string","format":null},"data da venda":{"origins":["data da venda"],"type":"date","format":"YYYY-MM-DD"},"hora da venda":{"origins":["hora da venda"],"type":"datetime","format":"HH:mm:ss"},"tipo de ingresso":{"origins":["tipo de ingresso"],"type":"string","format":null},"subtipo de ingresso":{"origins":["subtipo de ingresso"],"type":"string","format":null},"preço":{"origins":["preço"],"type":"decimal","format":null},"estado":{"origins":["estado"],"type":"string","format":null},"cidade":{"origins":["cidade"],"type":"string","format":null},"cep":{"origins":["cep"],"type":"string","format":null},"tipo de compra":{"origins":["tipo de compra"],"type":"string","format":null},"bandeira do cartao":{"origins":["bandeira do cartao"],"type":"string","format":null},"número de parcelas":{"origins":["número de parcelas"],"type":"string","format":null},"nome":{"origins":["nome"],"type":"string","format":null},"cpf":{"origins":["cpf"],"type":"string","format":null},"telefone":{"origins":["telefone"],"type":"string","format":null},"dia":{"origins":["dia"],"type":"date","format":"YYYY-MM-DD"},"sessão":{"origins":["sessão"],"type":"string","format":null},"id do pagamento":{"origins":["id do pagamento"],"type":"string","format":null},"marketing opt in":{"origins":["marketing opt in"],"type":"integer","format":null},"usuarios":{"origins":["usuarios"],"type":"string","format":null},"cards":{"origins":["cards"],"type":"integer","format":null},"possibilidade_assinar_club":{"origins":["possibilidade_assinar_club"],"type":"string","format":null},"tem_club":{"origins":["tem_club"],"type":"string","format":null},"score_visao_club":{"origins":["score_visao_club"],"type":"decimal","format":null},"frequentou_1_dia":{"origins":["frequentou_1_dia"],"type":"integer","format":null},"frequentou_2_dias":{"origins":["frequentou_2_dias"],"type":"integer","format":null},"frequentou_3_dias":{"origins":["frequentou_3_dias"],"type":"integer","format":null},"frequentou_4_dias":{"origins":["frequentou_4_dias"],"type":"integer","format":null},"frequentou_5_dias":{"origins":["frequentou_5_dias"],"type":"integer","format":null},"id":{"origins":["id do ingresso"],"type":"string"},"name":{"origins":[],"type":"string"},"sdkId":{"origins":[],"type":"string"},"email":{"origins":[],"type":"string"},"phone":{"origins":[],"type":"string"}}',
      //       primaryColumn: null,
      //       controlColumn: "",
      //       favorite: false,
      //       hasUpdatedAt: null,
      //       typeConfig: "csv",
      //       csvUrl: "CSVs/1708570244821-vendas_thetown.csv",
      //       csvSeparator: ";",
      //       apiEnabled: true,
      //       apiToken: "80317e8c-8bb4-4b07-8384-695775fdcdf6",
      //       skuType: null,
      //       csvLinebreak: "\r\n",
      //       errorBehaviour: "ignore",
      //     },
      //   },
      // ],
      confirmationFastJourney: false,
      choosenAudience: null,
      fastJourneyCurrentTemplate: null,
      currentAudiencesList: [],
      sortDesc: false,
      headers: [
        // { text: "", value: "favorite" },
        { text: "Nome", value: "templateName", sortable: true },
        { text: "Conexão", value: "databaseConfigId", sortable: true },
        {
          text: "Status",
          value: "infobipWhatsappTemplateStatus",
          sortable: true,
        },
        { text: "Tipo", value: "templateType", sortable: true },
        { text: "Criado em", value: "createdAt", sortable: true },
        { text: "Ações", value: "actions" },
      ],
      searchConnection: "",
      emailDialog: false,
      showInformations: false,
      pushDialog: false,
      smsDialog: false,
      optionsMenu: [
        { action: "email", text: "E-mail", value: 0 },
        { action: "push", text: "Push", value: 1 },
        { action: "sms", text: "SMS", value: 2 },
        { action: "wpp", text: "Whatsapp", value: 3 },
      ],
      optionsMenu2: [
        { action: "edit", text: "Editar", value: 1 },
        { action: "delete", text: "Apagar", value: 0 },
      ],
      http: new ApiClient(),
      dialogDelete: false,
      showAudienceModal: false,
      showSelectJourneyModal: false,

      // iconStyle2: {
      //   width: "23px",
      //   height: "23px",
      //   cursor: "pointer",
      //   paddding: "0px 5px 0px 0px",
      // },
      iconStyle: {
        width: "20px",
        height: "20px",
        cursor: "pointer",
      },
      iconStyle2: {
        width: "23px",
        height: "23px",
        cursor: "pointer",
      },
      cards: [],
      audienceModalData: [
        {
          name: "Criar nova jornada",
          description: "Criar uma jornada do zero.",
          icon: "/icons/people-icon.svg",
          value: 0,
          to: "/",
        },
        {
          name: "Selecionar jornada",
          description: "Selecionar uma jornada já criada anteriormente.",
          icon: "/icons/folder-icon.svg",
          value: 1,
          to: "/",
        },
      ],
      emailModalData: [
        {
          name: "Importar HTML",
          description: "Importar um modelo pronto em formato HTML.",
          icon: "/icons/upload-icon.svg",
          to: "create_email_templates",
          isToRenderTemplateOnStart: true,
        },
        {
          name: "Criar novo template",
          description: "Criar um novo template de e-mail do zero.",
          icon: "/icons/edit-icon.svg",
          to: "create_email_templates",
        },
        {
          name: "Selecionar template",
          description: "Selecionar uma template já criado pelo grupo.",
          icon: "/icons/folder-icon.svg",
          to: "/",
        },
      ],
      pushModalData: [
        {
          name: "Criar novo template",
          description: "Criar um novo template de push do zero.",
          icon: "/icons/edit-icon.svg",
          to: "create_push_templates",
        },
        {
          name: "Selecionar template",
          description: "Selecionar uma template já criado pelo grupo.",
          icon: "/icons/folder-icon.svg",
          to: "/",
        },
      ],
      smsModalData: [
        {
          name: "Criar novo template",
          description: "Criar um novo template de sms do zero.",
          icon: "/icons/edit-icon.svg",
          to: "create_sms_templates",
        },
        {
          name: "Selecionar template",
          description: "Selecionar uma template já criado pelo grupo.",
          icon: "/icons/folder-icon.svg",
          to: "/",
        },
      ],
      templateToBeDeleted: null,
      flagStyle: {
        color: "white",
        background: "#49CB8C",
        borderRadius: "50px",
        fontSize: "0.75em",
        fontWeight: 500,
        padding: ".05rem 0.45rem",
        minWidth: "60px",
        maxWidth: "58%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      cardAudienceStyle: {
        background: "#FFFFFF",
        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        padding: "1rem",
        flex: "1 1 230px",
        cursor: "pointer",
      },
      cardAudienceStyle2: {
        display: "flex",
        // alignItems: "flex-start",
        gap: "1rem",
        padding: "1rem 0",
        flexWrap: "wrap",
        color: "#333333",
      },
      favoriteTemplates: [],
      allTemplates: [],
      filtered: [],

      lastHeight: 508, // tamanho minimo para se ter dados,

      interval: null,
      currentTime: 0,
      loading: false,
      isEditingMode: false,
      hourInfo: "",
      minuteInfo: "",
      hoursArr: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      ignoreOptout: false,
      journeys: [],
      ignoreJourneys: [],
      audiences: [],
      ignoreAudiences: [],
      minutesArr: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
      ],
      toggle_week: "",
      startType: "",
      punctualTimerTypeEnd: "",
      endType: null,
      every: 1,
      punctualTimerType: "",
      recurringStartType: "",
      recurringEndType: "",
      timerType: "",
      repeatType: "",
      repeatItem: "weekly",
      executeTime: "",
      toggle_month: "",
      toggle_month_choose: null,
      finishNotificationEmails: "",
      fetchIntervalFn: null,
      duplicateSendInterval: null,
      duplicateSendIntervalType: null,
      shouldSentMensageriaToExistentContact: false,
      newUserJourneyEntryBehavior: null,
      userWaitBehaviour: "noChange",
      repeatItems: [
        {
          text: "Minuto",
          value: "minutely",
        },
        {
          text: "Hora",
          value: "hourly",
        },
        {
          text: "Dia",
          value: "daily",
        },
        {
          text: "Semana",
          value: "weekly",
        },
        {
          text: "Mês",
          value: "monthly",
        },
      ],

      repeatItems2: [
        {
          text: "Horas",
          value: "hour",
        },
        {
          text: "Dias",
          value: "daily",
        },
        {
          text: "Semanas",
          value: "weekly",
        },
      ],
      monthlyItens: [
        "Escolher um dia",
        "Dia 1",
        "Dia 5",
        "Dia 10",
        "Dia 15",
        "Dia 20",
        "Dia 25",
        "Dia 30",
      ],
      timeZones: [
        {
          text: "(GMT-3:00) - Horário de Brasília",
          value: "gmt-3",
        },
      ],
    };
  },
  beforeDestroy() {
    if (this.fetchIntervalFn) {
      clearInterval(this.fetchIntervalFn);
    }
  },
  async created() {
    await Promise.all([this.getTemplates(), this.getJourneys()]);

    this.fetchIntervalFn = setInterval(async () => {
      await this.getTemplates();
    }, 10000);
  },
  mounted() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        this.lastWidth = width;
        this.lastHeight = height;
      }
    });

    resizeObserver.observe(this.$refs.cardBody);
  },
  computed: {
    getFavorites() {
      return !this.searchConnection
        ? this.allTemplates.filter((item) => item.favorite == true)
        : this.filtered.filter((item) => item.favorite == true);
    },
    getNumberOfElements() {
      // const minimum_height = 587;
      const minimum_height = 570;
      let items_per_page = 9;

      if (this.lastHeight && this.lastHeight < minimum_height)
        items_per_page = 4;

      return items_per_page;
    },
  },
  watch: {
    searchConnection(nv) {
      this.getTemplatesByName(nv);
    },
  },
  methods: {
    editJourney(journey) {
      if (journey) this.$router.push(`/journey/edit/${journey.id}`);
      this.showSelectJourneyModal = false;
    },
    chooseMethodToJourney(info) {
      switch (info) {
        case 0:
          this.$router.push("/journey/");
          break;
        case 1:
          this.openSelectJourneyModal();
      }
    },
    openSelectJourneyModal() {
      this.showAudienceModal = false;
      this.showSelectJourneyModal = true;
    },
    getStatusName(info) {
      const enumTypes = {
        REJECTED: "Rejeitado",
        APPROVED: "Aprovado",
        PENDING: "Pendente",
        ACTIVE: "Ativo",
      };

      return enumTypes[info];
    },
    getStatusStyle(info) {
      const lower_info = info.toLowerCase();
      const flagStyle = {
        color: "#49CB8C",
        background: "#E1F2ED",
        borderRadius: "50px",
        fontSize: "0.90em",
        fontWeight: 500,
        padding: ".05rem 0.45rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1.6px solid #49CB8C",
        flex: "1",
      };

      switch (lower_info) {
        case "rejected":
          flagStyle.background = "#FFEDEF";
          flagStyle.color = "#CD445B";
          flagStyle.border = "1.6px solid #CD445B";
          break;
        case "pending":
          flagStyle.background = "#c2bebe";
          flagStyle.color = "black";
          flagStyle.border = "1.6px solid #c2bebe";
          break;
        case "pending_enroute":
          flagStyle.background = "#fae5aa";
          flagStyle.color = "#FF8F28";
          flagStyle.border = "1.6px solid #FF8F28";
      }

      return flagStyle;
    },
    getChipStyle(info) {
      const flagStyle = {
        color: "white",
        background: "#49CB8C",
        borderRadius: "50px",
        fontSize: "0.75em",
        fontWeight: 500,
        padding: ".05rem 0.45rem",
        //    minWidth: "60px",
        //   maxWidth: "58%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      };

      switch (info) {
        case "email":
          flagStyle.background = "#0273C3";
          break;
        case "push":
          flagStyle.background = "#FF8F28";
      }

      return flagStyle;
    },
    getTemplatesByName(name) {
      this.filtered = this.allTemplates.filter((item) =>
        item.templateName.toLocaleLowerCase().includes(name.toLocaleLowerCase())
      );
    },
    getConnectionName(item) {
      if (item.databaseConfig) return item.databaseConfig.name;
      else return "-";
    },
    async duplicateTemplate(template) {
      await this.http
        .get(`templatesConfiguration/findOne/${template.id}`)
        .then(async (resp) => {
          let templateToDuplicate = resp;

          await this.http
            .post(
              `templatesConfiguration/duplicateTemplatesConfigurations`,
              templateToDuplicate
            )
            .then(async () => {
              this.$toast.success("Templade duplicado com sucesso");
              await this.getTemplates();
            })
            .catch(() => {
              this.$toast.error("Erro ao duplicar o template");
            });
        })
        .catch(() => {
          this.$toast.error("Erro ao buscar template para duplicar");
        });
    },
    async confirmDeleteTemplate() {
      await this.http
        .delete(
          `templatesConfiguration/${this.templateToBeDeleted.id}`,
          this.templateToBeDeleted
        )
        .then(async () => {
          this.dialogDelete = false;
          await this.getTemplates();
          this.getTemplatesByName(this.searchConnection);
        })
        .catch((err) => {
          this.$toast.error(err.toString());
        });
    },
    onClickContextAction({ option }) {
      switch (option.value) {
        case 0:
          this.emailDialog = true;
          break;
        case 1:
          this.$router.push("templates/push");
          break;
        case 2:
          this.$router.push("templates/sms");
          break;
        case 3:
          this.$router.push("templates/whatsapp");
      }
    },
    goToPage(data) {
      const NAME = data.to;
      const SHOULD_RENDER_PRE_DATA = data?.isToRenderTemplateOnStart || false;
      this.$router.push({
        name: NAME,
        params: { shouldRenderPredata: SHOULD_RENDER_PRE_DATA },
      });
    },
    formateDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async getTemplates() {
      try {
        const req = await this.http.get("templatesConfiguration/list");
        this.allTemplates = req;
        console.log(req);
        this.favoriteTemplates = this.allTemplates.filter((x) => x.favorite);
        this.showInformations = true;
      } catch (error) {
        this.$toast.error("Erro ao listar configurações");
      }
    },
    async getJourneys() {
      const reqJourneys = await this.http.get("journey/list");

      this.journeys = reqJourneys.filter((x) => x.id !== this.$route.params.id);
    },
    async sortTable(nameToSort) {
      this.sortDesc = !this.sortDesc;
      try {
        const ORDER = this.sortDesc ? "ASC" : "DESC";
        const response = await this.http.get(
          `templatesConfiguration/list?sort=${nameToSort}&order=${ORDER}`
        );
        if (response) {
          this.allTemplates = response;
          if (this.searchConnection) {
            this.filtered =
              this.getTemplatesByName(this.searchConnection) || [];
          }
        }
      } catch (error) {
        this.$toast.error("Erro ao ordenar dados");
      }
    },
    async favoriteTemplate(item) {
      try {
        item.favorite = !item.favorite;
        await this.http.put(`templatesConfiguration/${item.id}`, item);
        this.getTemplates();
      } catch (error) {
        this.$toast.error("Erro ao realizar ação");
      }
    },

    selectOptionFromTable(item, option) {
      // console.log(item, option);
      switch (option) {
        case 0:
          this.templateToBeDeleted = item;
          this.dialogDelete = true;
          break;
        case 1:
          if (item.templateType === "email")
            this.$router.push(`/templates/email/new?id=${item.id}`);
          else if (item.templateType === "sms")
            this.$router.push(`/templates/sms?id=${item.id}`);
          else if (item.templateType === "push")
            this.$router.push(`/templates/push?id=${item.id}`);
          else if (item.templateType === "whatsapp")
            this.$router.push(`templates/whatsapp?id=${item.id}`);
          break;
        case 2:
          this.fastJourneyCurrentTemplate = item;
          this.getCurrentAudience(this.fastJourneyCurrentTemplate);
          break;
      }
    },
    async getCurrentAudience(template) {
      try {
        const res = await this.http.get(
          `audience/list?databaseConfigId=${template.databaseConfigId}`
        );
        this.currentAudiencesList = res;
        this.confirmationFastJourney = true;
      } catch (error) {
        console.error(error);
      }
    },

    createSimpleJourney() {
      if (this.$refs.confirmFastForm.validate()) {
        let obj = {};

        obj.template = { ...this.fastJourneyCurrentTemplate };
        obj.audience = { ...this.choosenAudience };

        let INIT_VALUE = "";
        let END_VALUE = this.endType;

        if (this.timerType === "punctual" && this.startType === "immediate") {
          INIT_VALUE = this.startType;
        } else {
          INIT_VALUE = this.punctualTimerType;
        }

        if (this.timerType === "recurring" && this.endType === "date") {
          END_VALUE = this.punctualTimerTypeEnd;
        }

        // if (this.timerType === "recurring"){
        this.executeTime = `${this.hourInfo}:${this.minuteInfo}`;
        // }

        const mountObj = {
          init: INIT_VALUE,
          end: END_VALUE,
          startType: this.startType,
          endType: this.endType,
          timerType: this.timerType,
          repeat: this.repeatType,
          interval: this.repeatItem,
          intervalValues: "",
          executeTime: this.executeTime,
          every: this.every,
          timezone: "gmt-3",
          punctualTimerType: this.punctualTimerType,
          punctualTimerTypeEnd: this.punctualTimerTypeEnd,
          duplicateSendInterval: this.duplicateSendInterval,
          duplicateSendIntervalType: this.duplicateSendIntervalType,
          newUserJourneyEntryBehavior: this.newUserJourneyEntryBehavior,
          userWaitBehaviour: this.userWaitBehaviour,
          shouldSentMensageriaToExistentContact:
            this.shouldSentMensageriaToExistentContact,
          ignoreOptout: this.ignoreOptout,
          ignoreJourneys: this.ignoreJourneys,
          finishNotificationEmails: this.finishNotificationEmails,
          ignoreAudiences: this.ignoreAudiences,
        };

        if (this.repeatItem == "weekly") {
          mountObj.intervalValues = this.toggle_week;
        } else if (this.repeatItem === "monthly") {
          mountObj.intervalValues =
            this.toggle_month !== "Escolher um dia"
              ? this.toggle_month
              : `Dia ${this.toggle_month_choose}`;
        }

        // this.$emit("close", mountObj);
        obj.mountObj = mountObj;

        this.$store.dispatch("app/CREATE_BASIC_JOURNEY", obj);

        this.$router.push("/journey");
      }
    },

    selectDotOption(item, option) {
      switch (option.value) {
        case 0:
          this.templateToBeDeleted = item;
          this.dialogDelete = true;
          break;
        case 1:
          if (item.templateType === "email")
            this.$router.push(`/templates/email/new?id=${item.id}`);
          else if (item.templateType === "sms")
            this.$router.push(`/templates/sms?id=${item.id}`);
          else if (item.templateType === "push")
            this.$router.push(`/templates/push?id=${item.id}`);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";

.list-options {
  background: #ffffff;
  &__item {
    padding: 0.5rem;
    cursor: pointer;
    transition: 0.2s ease;
    span {
      font-weight: 500;
    }
    &:hover {
      background: #e2e2e2;
    }
  }
}

.wrapper {
  color: $z-black-1;
  padding: $z-s-1;
  height: calc(100vh - 48px);
  &__card {
    padding: $z-s-1;
    background: #ffffff;
    border-radius: 15px;
    height: 100%;
    overflow-y: hidden;
    &__header {
      display: flex;
      align-items: center;
      gap: $z-s-1;
      margin-bottom: $z-s-2;
      flex-wrap: wrap;
      .left {
        flex: 1 1 auto;
        span {
          font-weight: 700;
          font-size: 1em;
          line-height: 15px;
          @media (max-width: 1063px) {
            font-size: 75%;
          }
        }
      }
      .right {
        flex: 2 1 600px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        gap: $z-s-1 0.5rem;
        & > div {
          &:first-child {
            width: 40%;
          }
        }

        @media (max-width: 808px) {
          justify-content: flex-start;
          & > div {
            flex: 1 1 350px;
          }
        }
      }
    }
    &__body {
      display: flex;
      flex-direction: column;
      gap: $z-s-1;
      height: 90%;
      .table-wrapper {
        height: 500px !important;
        max-height: 550px;
        overflow-y: auto;
        @include trackScrollBar;

        .no-data-table {
          text-align: center;
        }

        ::v-deep .v-data-table {
          table {
            th {
              &:first-child {
                min-width: 230px;
                max-width: 230px;
              }
              &:nth-child(2) {
                min-width: 230px;
                max-width: 230px;
              }
              &:not(:first-child) {
                text-align: right !important;
              }
            }
            td {
              &:first-child {
                min-width: 230px;
                max-width: 230px;
              }

              &:not(:first-child) {
                text-align: right !important;
              }
            }
          }
        }

        @media (min-width: 1550px) {
          height: auto;
          max-height: 650px;
        }
      }

      @media (min-width: 720px) and (max-width: 1079px) {
        .table-wrapper {
          height: 400px;
          max-height: 400px;
        }
      }

      @media (max-width: 890px) {
        height: auto;
        .table-wrapper {
          height: 350px;
          max-height: 350px;
        }
      }

      // // NOVAS TABELAS ADICIONADAS
      @media (min-width: 750px) {
        ::v-deep .v-data-table {
          table {
            th {
              &:not(:first-child) {
                text-align: center !important;
              }
              &:last-child {
                text-align: right !important;
              }
            }
            td {
              &:not(:first-child) {
                text-align: center !important;
                & > div,
                span {
                  margin: 0 auto !important;
                }
              }
              &:last-child {
                text-align: right !important;
              }
            }
          }
        }
      }

      &__cards {
        .item {
          // border: 2px solid red;
          height: 24vh;

          .content {
            height: 57%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            & > div {
              &:nth-child(1) {
                // border: 2px solid blue;
                max-height: 9vh;
                overflow-y: auto;
                &::-webkit-scrollbar {
                  width: 2px;
                }
              }
            }
          }

          @media (min-width: 1400px) {
            // background: red;
            height: 18vh;
          }

          @media (max-width: 750px) {
            .content {
              height: 70%;
            }
          }
        }
      }
    }
  }
}

.no-data {
  .wrapper__card {
    height: 50vh !important;
    display: flex;
    align-items: center;
    justify-content: center;
    .loader {
      border: 16px solid #f3f3f3;
      border-radius: 50%;
      border-top: 16px solid #3498db;
      width: 120px;
      height: 120px;
      -webkit-animation: spin 2s linear infinite; /* Safari */
      animation: spin 2s linear infinite;
    }
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    span {
      font-weight: 700;
      font-size: 1.1em;
      line-height: 15px;
    }
  }
}
</style>
